import { format, isValid, parseISO } from 'date-fns';

/**
 * Normalizes a value into a Date object or null.
 * Accepts a Date, string, or null.
 */

export function normalizeDateValue(
  input: Date | string | null | undefined,
): Date | null {
  if (!input) return null;

  if (input instanceof Date && isValid(input)) {
    return input;
  }

  if (typeof input === 'string') {
    const parsed = new Date(input);
    if (isValid(parsed)) return parsed;

    try {
      const parsedISO = parseISO(input);
      if (isValid(parsedISO)) return parsedISO;
    } catch {
      return null;
    }
  }

  return null;
}

export function formatDateValueToSave(date: Date | string) {
  return format(new Date(date), 'yyyy-MM-d');
}
